import React, {memo} from 'react';
import {useTranslations} from '../../hooks/use-translations';
import {UsedVehicle} from '../../typing/used-inventory';
import {clearText, separateThousand} from '../../utils/general';
import {
  StyledVin,
  StyledName,
  StyledModelTrim,
  StyledYear,
  StyledTitleWrapper,
  StyledPrice,
  StyledDistance,
  StyledModelNameTrim,
  StyledContainer,
  StyledModelName,
} from './styles';

interface DetailsTitleProps {
  readonly vehicle: UsedVehicle;
}

export const DetailsTitle: React.FC<DetailsTitleProps> = memo(
  (props): JSX.Element => {
    const translations = useTranslations().detailsSection.title;
    const {vehicle} = props;

    return vehicle ? (
      <StyledTitleWrapper className="title-wraper">
        <StyledContainer>
          <StyledName className="title-model-name notranslate">
            <StyledModelNameTrim>
              {vehicle.modelYear && (
                <StyledYear className="title-model-with-year">
                  {vehicle.modelYear}{' '}
                </StyledYear>
              )}
              {vehicle.model && (
                <StyledModelName>{vehicle.model} </StyledModelName>
              )}
              {vehicle.trimLevel && (
                <StyledModelTrim className="title-model-trim">
                  {clearText(vehicle.trimLevel)}
                </StyledModelTrim>
              )}
            </StyledModelNameTrim>
          </StyledName>
          {vehicle.vin && (
            <StyledVin className="notranslate">
              {translations.vin} {vehicle.vin}
            </StyledVin>
          )}
        </StyledContainer>
        <StyledContainer className="price-and-miles">
          {vehicle.adjustedListPrice && (
            <StyledPrice>
              {translations.moneySign}
              {separateThousand(vehicle.adjustedListPrice)}
            </StyledPrice>
          )}
          {vehicle.odometer && (
            <StyledDistance>
              {separateThousand(`${vehicle.odometer}`)} {translations.miles}
            </StyledDistance>
          )}
        </StyledContainer>
      </StyledTitleWrapper>
    ) : (
      <></>
    );
  },
);
